import { Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Component, EventEmitter, Output } from '@angular/core';
import { ListBase } from '../../../../../core/_infrastructure/classes/listBase';
import { NotificationService } from '../../../../../core/_infrastructure/classes/services/notification.service';
import { proxiedPropertiesOf } from '../../../../../core/_infrastructure/types/utils';
import { DatosCaPeriodoCamViewModel, ListaDatosCaPeriodoViewModel } from '../datosca.types';

@Component({
    selector: 'app-datosca-list',
    templateUrl: './datosca-list.component.html',
})
export class DatosCaListComponent extends ListBase implements OnInit, OnChanges {
    @Input() listaDatosCaPeriodo: ListaDatosCaPeriodoViewModel;
    @Input() esPeriodoFinalizado = false;
    @Output() editEmitter = new EventEmitter<number>();

    cols: any[];

    constructor(protected notificationService: NotificationService) {
        super(notificationService);
    }

    ngOnInit(): void {
        this.initCols();
        this.loading = false;
    }

    private initCols(): void {
        const datosCaPeriodo = proxiedPropertiesOf<DatosCaPeriodoCamViewModel>();

        this.cols = [
            { field: 'Link', header: '' },
            { field: datosCaPeriodo.Id?.toString(), header: 'Id', display: 'none' },
            { field: datosCaPeriodo.IdPeriodo?.toString(), header: 'IdPeriodo', display: 'none' },
            { field: datosCaPeriodo.ComunidadAutonoma?.toString(), header: 'Comunidad Autónoma' },
            { field: datosCaPeriodo.NombreUsuario?.toString(), header: 'Nombre' },
            { field: datosCaPeriodo.ApellidosUsuario?.toString(), header: 'Apellidos' },
            { field: datosCaPeriodo.EntidadAuditora?.toString(), header: 'Entidades Auditoras' },
            { field: datosCaPeriodo.ProgramaVerificacion?.toString(), header: 'Programa de Verificación' },
        ];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.listaDatosCaPeriodo?.currentValue) {
            this.listaDatosCaPeriodo.DatosCaPeriodoCollection = [...changes.listaDatosCaPeriodo.currentValue.DatosCaPeriodoCollection];
            this.loading = false;
        }
    }

    onEdit(item: DatosCaPeriodoCamViewModel): void {
        this.editEmitter.emit(item?.Id);
    }
}
